import React from "react";

const formatDate = (fecha) => {
  if (!fecha) return "-";
  try {
    return new Date(fecha).toLocaleDateString("es-MX");
  } catch {
    return "-";
  }
};

// Un valor cuenta como "respondido" si no está vacío ni en -1
const tieneRespuesta = (v) =>
  v !== undefined &&
  v !== null &&
  String(v).trim() !== "" &&
  String(v).trim() !== "-1";

// En mediciones (cintura, glucosa) el 0 significa "no se midió"
const tieneMedicion = (v) => tieneRespuesta(v) && Number(v) !== 0;

// Arma el texto de glucosa: "95 (en ayunas · tira capilar)"
const textoGlucosa = (row) => {
  if (!tieneMedicion(row.glucemia)) return null;

  const detalles = [];
  if (String(row.tipoMedicion) === "1") detalles.push("en ayunas");
  if (String(row.tipoMedicion) === "0") detalles.push("sin ayuno");
  if (String(row.resultadoObtenidoaTravesde) === "1") detalles.push("laboratorio");
  if (String(row.resultadoObtenidoaTravesde) === "2") detalles.push("tira capilar");

  return detalles.length
    ? `${row.glucemia} (${detalles.join(" · ")})`
    : String(row.glucemia);
};

const ExploracionFisicaPaciente = ({ historiaClinica }) => {
  if (!historiaClinica) {
    return (
      
        <div className="exploracion-empty">Sin consultas previas</div>
     
    );
  }

  // 🔹 MISMO ARMADO QUE LEGACY
  const filas = [
    {
      fecha:
        historiaClinica.fechaConsulta ||
        historiaClinica.fecha_creacion ||
        historiaClinica.creado_en,

      peso: historiaClinica["exploracionFisica.peso"],
      altura: historiaClinica["exploracionFisica.altura"],

      presionArterial:
        historiaClinica.sistolica && historiaClinica.diastolica
          ? `${historiaClinica.sistolica}/${historiaClinica.diastolica}`
          : historiaClinica[
              "exploracionFisica.signosVitales.presionArterial"
            ],

      frecuenciaCardiaca:
        historiaClinica[
          "exploracionFisica.signosVitales.frecuenciaCardiaca"
        ],

      frecuenciaRespiratoria:
        historiaClinica[
          "exploracionFisica.signosVitales.frecuenciaRespiratoria"
        ],

      temperatura:
        historiaClinica[
          "exploracionFisica.signosVitales.temperatura"
        ],

      saturacionOxigeno:
        historiaClinica[
          "exploracionFisica.signosVitales.saturacionOxigeno"
        ],

      imc: historiaClinica.imc,
      categoria_imc: historiaClinica.categoria_imc,
      circunferenciaCintura: historiaClinica.circunferenciaCintura,
      glucemia: historiaClinica.glucemia,
      tipoMedicion: historiaClinica.tipoMedicion,
      resultadoObtenidoaTravesde: historiaClinica.resultadoObtenidoaTravesde,
    },

    ...(Array.isArray(historiaClinica.consultas)
      ? historiaClinica.consultas.map((c) => ({
          fecha:
            c.fecha_consulta || c.fechaConsulta || c.creado_en,

          peso: c["exploracionFisica.peso"],
          altura: c["exploracionFisica.altura"],

          presionArterial:
            c.sistolica && c.diastolica
              ? `${c.sistolica}/${c.diastolica}`
              : c[
                  "exploracionFisica.signosVitales.presionArterial"
                ],

          frecuenciaCardiaca:
            c[
              "exploracionFisica.signosVitales.frecuenciaCardiaca"
            ],

          frecuenciaRespiratoria:
            c[
              "exploracionFisica.signosVitales.frecuenciaRespiratoria"
            ],

          temperatura:
            c[
              "exploracionFisica.signosVitales.temperatura"
            ],

          saturacionOxigeno:
            c[
              "exploracionFisica.signosVitales.saturacionOxigeno"
            ],

          imc: c.imc,
          categoria_imc: c.categoria_imc,
          circunferenciaCintura: c.circunferenciaCintura,
          glucemia: c.glucemia,
          tipoMedicion: c.tipoMedicion,
          resultadoObtenidoaTravesde: c.resultadoObtenidoaTravesde,
        }))
      : []),
  ].sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
  // Las columnas nuevas solo aparecen si al menos una consulta tiene el dato
  const mostrarCintura = filas.some((r) => tieneMedicion(r.circunferenciaCintura));
  const mostrarGlucosa = filas.some((r) => textoGlucosa(r) !== null);

  return (
    <section className="paciente-folder exploracion-fisica">
      <h2>Evolución de signos vitales</h2>

      <div className="tabla-scroll">
        <table className="tabla-signos">
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Peso (kg)</th>
              <th>Altura (m)</th>
              <th>Presión Arterial (mmHg)</th>
              <th>Frecuencia Cardiaca (lpm)</th>
              <th>Frecuencia Respiratoria (rpm)</th>
              <th>Temperatura (°C)</th>
              <th>Saturación de Oxígeno (%)</th>
              <th>IMC</th>
              <th>Categoría IMC</th>
              {mostrarCintura && <th>Circunferencia de cintura (cm)</th>}
              {mostrarGlucosa && <th>Glucosa (mg/dl)</th>}
            </tr>
          </thead>

          <tbody>
            {filas.map((row, idx) => (
              <tr key={idx}>
                <td>{formatDate(row.fecha)}</td>
                <td>{row.peso ?? "-"}</td>
                <td>{row.altura ?? "-"}</td>
                <td>{row.presionArterial ?? "-"}</td>
                <td>{row.frecuenciaCardiaca ?? "-"}</td>
                <td>{row.frecuenciaRespiratoria ?? "-"}</td>
                <td>{row.temperatura ?? "-"}</td>
                <td>{row.saturacionOxigeno ?? "-"}</td>
                <td>{row.imc ?? "-"}</td>
                <td>{row.categoria_imc ?? "-"}</td>
                 {mostrarCintura && (
                  <td>
                    {tieneMedicion(row.circunferenciaCintura)
                      ? row.circunferenciaCintura
                      : "-"}
                  </td>
                )}
                {mostrarGlucosa && <td>{textoGlucosa(row) ?? "-"}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ExploracionFisicaPaciente;
